/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {
  createDialogRoute,
  FormState,
  FormStateBuilder,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { DialogInput, FormMode } from '@gh/core-ui';
import { assign } from 'lodash';
import { RfqHeadingListItem } from '../../resources/rfq-structure.model';

export interface HeadingLineDialogConfig {
  headingLine: RfqHeadingListItem;
}

@Component({
  standalone: false,
  selector: 'gh-heading-line-dialog',
  templateUrl: 'heading-line-dialog.component.html',
  styleUrls: ['heading-line-dialog.component.scss'],
})
export class HeadingLineDialogComponent implements OnInit, DialogInput<HeadingLineDialogConfig> {
  input: HeadingLineDialogConfig;
  form: FormState<RfqHeadingListItem>;
  headingLineItem?: RfqHeadingListItem;

  constructor(private dialogRef: MatDialogRef<any>,
              private formStateBuilder: FormStateBuilder) {

  }

  ngOnInit(): void {
    const headingLineItem = this.input.headingLine;

    assign(this, { headingLineItem });

    this.form = this.formStateBuilder.buildPlain({
      value: headingLineItem,
      mode: headingLineItem ? FormMode.EditMode : FormMode.CreateMode,
      enabled: whenCreateOrEditMode(),
      children: {
        description: { required: true },
      },
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onApply(): void {
    if (this.form.group.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.dialogRef.close({
      ...this.headingLineItem,
      description: this.form.value.description,
    });

  }
}

export const headingLineDialogRoute = createDialogRoute({
  component: HeadingLineDialogComponent,
});
